import { render, staticRenderFns } from "./courier.vue?vue&type=template&id=4dbc136c"
import script from "./courier.vue?vue&type=script&lang=js"
export * from "./courier.vue?vue&type=script&lang=js"
import style0 from "./courier.vue?vue&type=style&index=0&id=4dbc136c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports